/**
 * @generated SignedSource<<7c28a5d9f15dddc3a15a22a8bf357833>>
 * @relayHash 0187c889600328eec9299ef7b4a638a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a40c7cd4b2c60e6d23a2e31ed930334b7e6d3e71754052fdcbdb900e4dffca3c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type layoutRendererRefetchQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  helpCenterAri: string;
  id: string;
};
export type layoutRendererRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"layoutViewRendererFragment">;
  } | null;
};
export type layoutRendererRefetchQuery = {
  response: layoutRendererRefetchQuery$data;
  variables: layoutRendererRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "logo"
},
v8 = {
  "kind": "ScalarField",
  "name": "portalId"
},
v9 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "titleColor"
    }
  ]
},
v10 = {
  "concreteType": "HelpLayoutAtomicElementType",
  "kind": "LinkedField",
  "name": "elementType",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "message"
},
v12 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v15 = {
  "kind": "ScalarField",
  "name": "backgroundType"
},
v16 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "layoutRendererRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "layoutViewRendererFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "layoutRendererRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "HelpLayoutSectionConnection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "HelpLayoutSectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "HelpLayoutSection",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpLayoutSubsection",
                            "kind": "LinkedField",
                            "name": "subsections",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "HelpLayoutSubsectionConfig",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "span"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "elements",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "adf"
                                      },
                                      {
                                        "concreteType": "HelpLayoutAtomicElementType",
                                        "kind": "LinkedField",
                                        "name": "elementType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "args": [
                                              {
                                                "kind": "Variable",
                                                "name": "parentAri",
                                                "variableName": "helpCenterAri"
                                              }
                                            ],
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "mediaCollectionName"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "mediaToken"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "mediaUrl"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "asapIssuer"
                                              }
                                            ]
                                          },
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "HelpLayoutEditorElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutPortalCard",
                                        "kind": "LinkedField",
                                        "name": "portals",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "description"
                                          },
                                          (v7/*: any*/),
                                          (v8/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "isFeatured"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "expandButtonTextColor"
                                      },
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutPortalsListElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutRequestForm",
                                        "kind": "LinkedField",
                                        "name": "suggestedRequestTypes",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "descriptionHtml"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "portalName"
                                          },
                                          (v3/*: any*/),
                                          (v8/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                          }
                                        ]
                                      },
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "header"
                                      },
                                      (v11/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutAnnouncementElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutTopic",
                                        "kind": "LinkedField",
                                        "name": "topics",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "topicId"
                                          },
                                          (v12/*: any*/),
                                          {
                                            "concreteType": "HelpLayoutTopicItem",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "title"
                                              },
                                              (v7/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "displayLink"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "entityKey"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "helpObjectType"
                                              },
                                              (v13/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "topicName"
                                          }
                                        ]
                                      },
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutTopicsListElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "useGlobalSettings"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "homePageTitle"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "userLanguageTag"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "showCSMAISearchTrigger"
                                      },
                                      {
                                        "concreteType": "HelpLayoutVisualConfig",
                                        "kind": "LinkedField",
                                        "name": "visualConfig",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "foregroundColor"
                                          },
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutHeroElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutNoContentElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "forgeElementType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "forgeElementPage"
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutForgeElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "connectElementPage"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "connectElementType"
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutConnectElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "identifier"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "extensions",
                                        "plural": true,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                          }
                                        ]
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "type": "QueryError"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutBreadcrumb",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "relativeUrl"
                                          },
                                          (v6/*: any*/)
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "type": "HelpLayoutBreadcrumbElement"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "HelpLayoutVisualConfig",
                                    "kind": "LinkedField",
                                    "name": "visualConfig",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutAlignmentSettings",
                                        "kind": "LinkedField",
                                        "name": "alignment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "horizontalAlignment"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "verticalAlignment"
                                          },
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "HelpLayoutVisualEntity",
                                "abstractKey": "__isHelpLayoutVisualEntity"
                              },
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "HelpLayoutVisualConfig",
                            "kind": "LinkedField",
                            "name": "visualConfig",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v12/*: any*/)
                            ]
                          },
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v4/*: any*/),
                "handle": "connection",
                "key": "layoutRendererFragment_sections",
                "kind": "LinkedHandle",
                "name": "sections"
              }
            ],
            "type": "HelpLayout"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a40c7cd4b2c60e6d23a2e31ed930334b7e6d3e71754052fdcbdb900e4dffca3c",
    "metadata": {},
    "name": "layoutRendererRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f0e36a298e34cd645390386fd7cd202a";

export default node;
